<style>
</style>

<template>
    <div class="animated fadeIn">
        <b-tabs fill>
            <b-tab>
                <template slot="title">
                    {{Core.Definition.getDefinition('Client')}}
                </template>

                <DynamicForm
                        class="mt-3"
                        ref="dynamicFormCustomer"
                        getRoot="/setting/auto-notification-customer"
                        saveRoot="/setting/auto-notification-customer"
                        @onRequestSuccess="onRequestSuccessAutoNotificationCustomer"
                        @onSave="onSaveCustomer"
                        :formStructure="dataFormStructures.customer">
                    <slot slot="autoNotificationCustomer">
                        <b-row>
                            <b-col>
                                <InputSelect
                                        :label="Core.Definition.getDefinition('Liste des notifications')"
                                        :options="dataAutoNotificationCustomerOptions"
                                        @onSelect="onSelectAutoNotificationCustomer"
                                        v-model="dataAutoNotificationCustomer"></InputSelect>
                            </b-col>
                            <b-col>
                                <b-alert class="mt-4" show variant="light" v-if="dataAutoNotificationCustomer.data !== undefined">
                                    {{dataAutoNotificationCustomer.data.description}}
                                </b-alert>
                                <b-alert v-else class="mt-4" show variant="warning">
                                    {{Core.Definition.getDefinition('Sélectionnez un message à modifier')}}
                                </b-alert>
                            </b-col>
                        </b-row>
                        
                        <hr/>

                        <b-row v-if="dataAutoNotificationCustomer.data !== undefined">
                            <b-col>
                                <b-card>
                                    <div slot="header">
                                        {{Core.Definition.getDefinition('Courriel')}}
                                    </div>
                                    <div v-if="dataAutoNotificationCustomer.data.email !== undefined">
                                        <b-row>
                                            <b-col>
                                                <InputCheckbox
                                                        :label="Core.Definition.getDefinition('Activé')"
                                                        v-model="dataAutoNotificationCustomer.data.email.activated"></InputCheckbox>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>
                                                <InputText
                                                        :label="Core.Definition.getDefinition('Sujet')"
                                                        v-model="dataAutoNotificationCustomer.data.email.subject"></InputText>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>
                                                <InputEditor
                                                        :label="Core.Definition.getDefinition('Contenu')"
                                                        v-model="dataAutoNotificationCustomer.data.email.content"></InputEditor>
                                            </b-col>
                                        </b-row>
                                    </div>
                                    <div v-else>
                                        <b-alert class="mt-4" show variant="warning">
                                            {{Core.Definition.getDefinition('L\'envoi par courriel n\'a pas été activé pour ce message.')}}
                                        </b-alert>
                                    </div>
                                </b-card>
                            </b-col>
                            <b-col>
                                <b-card>
                                    <div slot="header">
                                        {{Core.Definition.getDefinition('SMS')}}
                                    </div>
                                    <div v-if="dataAutoNotificationCustomer.data.sms !== undefined">
                                        <b-row>
                                            <b-col>
                                                <InputCheckbox
                                                        :label="Core.Definition.getDefinition('Activé')"
                                                        v-model="dataAutoNotificationCustomer.data.sms.activated"></InputCheckbox>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>
                                                <InputLongText
                                                        :label="Core.Definition.getDefinition('Contenu')"
                                                        v-model="dataAutoNotificationCustomer.data.sms.content"></InputLongText>
                                            </b-col>
                                        </b-row>
                                    </div>
                                    <div v-else>
                                        <b-alert class="mt-4" show variant="warning">
                                            {{Core.Definition.getDefinition('L\'envoi par SMS n\'a pas été activé pour ce message.')}}
                                        </b-alert>
                                    </div>
                                </b-card>
                            </b-col>
                        </b-row>
                    </slot>
                </DynamicForm>

            </b-tab>
            <b-tab>
                <template slot="title">
                    {{Core.Definition.getDefinition('Administration')}}
                </template>

                <DynamicForm
                        class="mt-3"
                        ref="dynamicFormAdmin"
                        getRoot="/setting/auto-notification-admin"
                        saveRoot="/setting/auto-notification-admin"
                        @onRequestSuccess="onRequestSuccessAutoNotificationAdmin"
                        @onSave="onSaveAdmin"
                        :formStructure="dataFormStructures.admin">
                    <slot slot="autoNotificationAdmin">
                        <b-row>
                            <b-col>
                                <InputSelect
                                        :label="Core.Definition.getDefinition('Liste des notifications')"
                                        :options="dataAutoNotificationAdminOptions"
                                        @onSelect="onSelectAutoNotificationAdmin"
                                        v-model="dataAutoNotificationAdmin"></InputSelect>
                            </b-col>
                            <b-col>
                                <b-alert class="mt-4" show variant="light" v-if="dataAutoNotificationAdmin.data !== undefined">
                                    {{dataAutoNotificationAdmin.data.description}}
                                </b-alert>
                                <b-alert v-else class="mt-4" show variant="warning">
                                    {{Core.Definition.getDefinition('Sélectionnez un message à modifier')}}
                                </b-alert>
                            </b-col>
                        </b-row>

                        <hr/>

                        <b-row v-if="dataAutoNotificationAdmin.data !== undefined">
                            <b-col>
                                <b-card>
                                    <div slot="header">
                                        {{Core.Definition.getDefinition('Courriel')}}
                                    </div>
                                    <div v-if="dataAutoNotificationAdmin.data.email !== undefined">
                                        <b-row>
                                            <b-col>
                                                <InputCheckbox
                                                        :label="Core.Definition.getDefinition('Activé')"
                                                        v-model="dataAutoNotificationAdmin.data.email.activated"></InputCheckbox>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>
                                                <InputText
                                                        :label="Core.Definition.getDefinition('Sujet')"
                                                        v-model="dataAutoNotificationAdmin.data.email.subject"></InputText>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>
                                                <InputEditor
                                                        :label="Core.Definition.getDefinition('Contenu')"
                                                        v-model="dataAutoNotificationAdmin.data.email.content"></InputEditor>
                                            </b-col>
                                        </b-row>
                                    </div>
                                    <div v-else>
                                        <b-alert class="mt-4" show variant="warning">
                                            {{Core.Definition.getDefinition('L\'envoi par courriel n\'a pas été activé pour ce message.')}}
                                        </b-alert>
                                    </div>
                                </b-card>
                            </b-col>
                            <b-col>
                                <b-card>
                                    <div slot="header">
                                        {{Core.Definition.getDefinition('SMS')}}
                                    </div>
                                    <div v-if="dataAutoNotificationAdmin.data.sms !== undefined">
                                        <b-row>
                                            <b-col>
                                                <InputCheckbox
                                                        :label="Core.Definition.getDefinition('Activé')"
                                                        v-model="dataAutoNotificationAdmin.data.sms.activated"></InputCheckbox>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>
                                                <InputLongText
                                                        :label="Core.Definition.getDefinition('Contenu')"
                                                        v-model="dataAutoNotificationAdmin.data.sms.content"></InputLongText>
                                            </b-col>
                                        </b-row>
                                    </div>
                                    <div v-else>
                                        <b-alert class="mt-4" show variant="warning">
                                            {{Core.Definition.getDefinition('L\'envoi par SMS n\'a pas été activé pour ce message.')}}
                                        </b-alert>
                                    </div>
                                </b-card>
                            </b-col>
                        </b-row>
                    </slot>
                </DynamicForm>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import DynamicForm from '../../../components/DynamicForm'
    import InputSelect from '../../../components/InputSelect'
    import InputText from '../../../components/InputText'
    import InputEditor from '../../../components/InputEditor'
    import InputLongText from '../../../components/InputLongText'
    import InputCheckbox from '../../../components/InputCheckbox'
    export default {
        name: 'SettingsAutoNotifications',
        components: {
            DynamicForm,
            InputSelect,
            InputText,
            InputCheckbox,
            InputEditor,
            InputLongText
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataFormStructures: {
                    customer: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                key: 'autoNotificationCustomer',
                                                options: { class: 'card-no-border'}
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: []
                    },
                    admin: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                key: 'autoNotificationAdmin',
                                                options: { class: 'card-no-border'}
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: []
                    }
                },
                dataAutoNotificationCustomerOptions: [],
                dataAutoNotificationCustomer: '',
                dataAutoNotificationAdminOptions: [],
                dataAutoNotificationAdmin: ''
            }
        },
        computed: {
        },
        methods: {
            onRequestSuccessAutoNotificationCustomer(data) {
                if (data.autoNotificationCustomerOptions !== undefined) {
                    this.dataAutoNotificationCustomerOptions = data.autoNotificationCustomerOptions
                }
            },
            onSelectAutoNotificationCustomer(val) {
            },
            onRequestSuccessAutoNotificationAdmin(data) {
                if (data.autoNotificationAdminOptions !== undefined) {
                    this.dataAutoNotificationAdminOptions = data.autoNotificationAdminOptions
                }
            },
            onSelectAutoNotificationAdmin(val) {
            },
            onSaveAdmin() {
                this.$refs.dynamicFormAdmin.addSaveArg('autoNotificationAdmin',this.dataAutoNotificationAdminOptions, Core.Value.typeJSON)
            },
            onSaveCustomer() {
                this.$refs.dynamicFormCustomer.addSaveArg('autoNotificationCustomer',this.dataAutoNotificationCustomerOptions, Core.Value.typeJSON)
            }
        }
    }
</script>
